export enum AdminBannerListItemAction {
  Edit,
  Preview,
  Remove,
}
